import React from "react";
import content from "../utils/content.json";
function Contact() {
  return (
    <div className="background">
      <div id="contact" className="container section">
        <div className="row">
          <div className="col-md-12">
            <p id="contacts_header" className="section__title">
              Get in touch_
            </p>
          </div>
        </div>
        <div className="row contacts">
          <div className="col-md-6">
            <div className="contacts__list">
              <dl className="contact-list">
                <dt>Phone:</dt>
                <dd>
                  <a href={`tel:${content.content.profile.contacts.phone}`}>
                    {content.content.profile.contacts.phone}
                  </a>
                </dd>
                <dt>Email:</dt>
                <dd>
                  <a href={`mailto:${content.content.profile.contacts.email}`}>
                    {content.content.profile.contacts.email}
                  </a>
                </dd>
              </dl>
            </div>
            <div className="contacts__display">
              <div className="contacts__qrcode">
                <img src="/images/mycontact.png" />
                <p>For a quick contact scan the QR code to get all my info</p>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="contacts__form">
              <p className="contacts__form-title">
                Or just write me a message here_
              </p>
              <a
                href="https://forms.gle/z5zNRUGsU5WAHC369"
                target="_blank"
                className="btn site-btn"
              >
                Google Message
              </a>
            </div>
            <div className="contacts__social">
              <br />
              <ul>
                <li>
                  <a
                    href={content.content.profile.social.github}
                    target="_blank"
                    rel="noreferrer"
                  >
                    GitHub
                  </a>
                </li>
                <li>
                  <a
                    href={content.content.profile.social.linkedin}
                    target="_blank"
                    rel="noreferrer"
                  >
                    LinkedIn
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="footer">
            <p>
              © {new Date().getFullYear()} Ravindra Singh Shah. All Rights
              Reserved
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
